export default {
  retrieveDropRouteList(state, payload) {
    state.dropRouteList = [].concat(payload.dropRouteList)
  },
  getDropRouteInfo(state, payload) {
    state.dropRouteInfo = payload.dropRouteInfo
    for (const [key, value] of Object.entries(state.dropRouteInfo.place_list)) {
      state.selected[key] = value.id.toString();
    }
    // for (const [key, value] of Object.entries(state.dropRouteInfo.bus_list)) {
    //   state.selectedBus[key] = value.id.toString();
    // }
    state.dropRouteStudentList = payload.dropRouteInfo.student_list
    state.scheduleInfo = state.dropRouteInfo.schedule_info
  },
  deleteDropRoute(state, payload) {
    state.dropRouteList.splice(payload.dropRouteInfo.index, 1);
  },
  didSelectPlace(state, payload) {
    state.dropRouteInfo.place_list[payload.dropRouteInfo.selectData[1]].id = payload.dropRouteInfo.selectData[0]
    state.selected[payload.dropRouteInfo.selectData[1]] = payload.dropRouteInfo.selectData[0]
  },
  didSelectBus2(state, payload) {
    state.dropRouteInfo.bus_list[payload.dropRouteInfo.selectData[1]].id = payload.dropRouteInfo.selectData[0]
    state.selectedBus[payload.dropRouteInfo.selectData[1]] = payload.dropRouteInfo.selectData[0]
  },
  removePlace(state, payload) {
    state.selected.splice(payload.data.index, 1)
    state.dropRouteInfo.place_list.splice(payload.data.index, 1)
  },
  removeBus(state, payload) {
    state.selectedBus.splice(payload.data.index, 1)
    state.dropRouteInfo.bus_list.splice(payload.data.index, 1)
  },
  addPlace(state, payload) {
    state.dropRouteInfo.place_list.push({id: ""})
  },
  addBus(state, payload) {
    state.dropRouteInfo.bus_list.push({id: ""})
  },
  addStudent(state, payload) {
    state.dropRouteStudentList.push({
      id: null,
      name: ''
    })
  },
  studentSet(state, payload) {
    state.dropRouteStudentList[payload.index].id = payload.id
    state.dropRouteStudentList[payload.index].name = payload.name
  },
  removeStudent(state, payload) {
    state.dropRouteStudentList.splice(payload, 1)
  },
  addSchedule(state) {
    state.scheduleInfo.push(
      {
        date: "-1",
        bus_list: [{
          id: "-1",
          place_list: [
            {
              id: "-1",
              time: ""
            }
          ]
        }]
      }
    )
  },

  addPlaceForSchedule(state, payload) {
    state.scheduleInfo[payload.index].bus_list[payload.indexBus].place_list.push({id: "-1", time: ""})
  },

  addBusForSchedule(state, payload) {
    state.scheduleInfo[payload.index].bus_list.push({
      id: "-1",
      place_list: [
        {
          id: "-1",
          time: ""
        }
      ]
    })
  },

  removePlaceForSchedule(state, payload) {
    state.scheduleInfo[payload.index].bus_list[payload.indexBus].place_list.splice(payload.indexPlace, 1)
  },

  removeBusForSchedule(state, payload) {
    state.scheduleInfo[payload.index].bus_list.splice(payload.indexBus, 1)
  },

  removeSchedule(state, payload) {
    state.scheduleInfo.splice(payload, 1)
  },

  didSelectWeekDay(state, payload) {
    state.scheduleInfo[payload[1]].day = payload[0]
  },

  didSelectBus(state, payload) {
    state.scheduleInfo[payload[2]].bus_list[payload[1]].id = payload[0]
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
